module.exports = __webpack_public_path__ + "img/Ai.22305d74.svg";